import { TournamentEntity } from 'app/interfaces/entity';
import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';

export const getTournamentsList = () => {
  return apiRequestCall<TournamentEntity[]>({
    params: {
      method: 'GET',
      resource: ApiResource.Admin,
      urlPrefix: ApiResource.Tournaments,
    },
  });
};
